import { EntityStatus } from '../../../core/interfaces/entity-status';

export class Invoice {
  id: string;
  number: string;
  amount: number;
  createdTimestamp: number;
  status: EntityStatus;
  invoiceUrl: string;
  paymentUrl: string;
  failureMessage?: string;
}
